// ** React Imports
import { useState, useEffect, SyntheticEvent, ChangeEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete,
    TableCell
} from '@mui/material'

import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import moment from 'moment';
import React from 'react';


export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [valSupplier, setValSupplier] = useState<any>(null)
    const [listSupplier, setListSupplier] = useState<any[]>([])

    const [rowsDataDetail, setRowsDataDetail] = useState<any[]>([])
    const [sumBarang, setSumBarang] = useState<string>('')

    const [openBarang, setOpenBarang] = useState<boolean>(false)
    const [isDetailBarang, setIsDetailBarang] = useState<boolean>(false)
    const [listDetailBarang, setListDetailBarang] = useState<any[]>([])

    // add lampiran
    const [keterangan, setKeterangan] = useState<string>('')
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<any>(null)
    const [jenisLampiran, setJenisLampiran] = useState<any>('')
    const [listLampiran, setListLampiran] = useState<any[]>([])
    const [dialogLampiran, setDialogLampiran] = useState<boolean>(false)

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/purchasing/inquiry/detail'
        axios
            .get(url, {
                params: { id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    const listBarang = response.data.data_barang
                    setValue('created_at', data.tgl?.substring(0, 10))
                    setValue('eta', data.eta?.substring(0, 10))
                    setValue('keterangan', data.keterangan)

                    setRowsDataDetail(listBarang)
                    setSumBarang(response.data.total)

                    getSupplier(data.nama_vendor)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getLampiran = () => {
        const url = apiUrl.apiUrl + '/purchasing/inquiry/detail-list-lampiran?id=' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListLampiran(data)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSupplier = (nama: any) => {
        const url = apiUrl.apiUrl + '/purchasing/inquiry/list-vendor'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.nama == nama) {
                            setValSupplier(element)
                            setValue('pbsupplier_id', element.id)
                        }
                    });
                    setListSupplier(data)

                    getLampiran()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getListMasterBarangNew = () => {
        const url = apiUrl.apiUrl + '/purchasing/inquiry/list-barang'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetailBarang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any
        sysdoctag_id: any
        keterangan: any
        detailBarang: any
        total: any
        id: any
        pbsupplier_id: string
        eta: any
        created_at: any
    }

    const defaultValues = {
        syscabang_id: cabang,
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleClickDialog = (x: any) => {
        setOpenBarang(true)
        getListMasterBarangNew()
        setIsDetailBarang(x)
    }
    const handleCloseDialog = () => setOpenBarang(false)

    const handleChangeAutocompleteSupplier = (event: SyntheticEvent, newValue: any | null) => {
        setValue('pbsupplier_id', newValue?.id)
        setValSupplier(newValue)
    }

    const handleCloseLampiran = () => setDialogLampiran(false)

    const handleChangeKeterangan = (event: ChangeEvent<HTMLInputElement>) => {
        setKeterangan(event.target.value)
    }

    const handleChangeJenisLampiran = (event: SelectChangeEvent) => {
        setJenisLampiran(event.target.value as string)
    }

    const rowClickBarang = (e: any) => {
        const data = e.data
        addDetailBarang(data.id)
        setOpenBarang(false)
    }

    const addDetailBarang = (mb_id: any) => {

        const url = apiUrl.apiUrl + '/purchasing/pr/check-barang/' + mb_id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach((element: any) => {
                        const rowsInput = {
                            id: '',
                            mmbarang_id: element.mmbarang_id,
                            mmsatuan_id: element.mmsatuan_id,
                            mmsatuan_doc_id: element.mmsatuan_doc_id,
                            Nama_Barang: element.Nama_Barang,
                            Keterangan: element.Keterangan,
                            Quantity: element.Quantity,
                            konversi: element.konversi,
                            Harga: element.Harga,
                            Harga_Usd: element.Harga_Usd,
                            Satuan: element.Satuan,
                            Total: element.Total
                        }
                        setRowsDataDetail([...rowsDataDetail, rowsInput])
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
    }

    const tambahLampiran = () => {
        let msg = ''

        if (jenisLampiran == '') {
            msg += 'belum memilih Jenis Lampiran </br>'
        }

        if (file == null) {
            msg += 'File belum dipilih </br>'
        }

        if (msg == '') {
            handleCloseLampiran()
            Swal.fire({
                title: 'Konfirmasi',
                html: 'Apakah anda ingin menambahkan lampiran?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#337ab7',
                cancelButtonColor: '#ffc107',
                confirmButtonText: 'Tambah'
            }).then(result => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Now loading',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading()
                        }
                    })

                    const formData = new FormData()
                    formData.append('jenis_lampiran', jenisLampiran)
                    formData.append('file', file)
                    formData.append('keterangan', keterangan)
                    formData.append('nama_file', file.name)

                    const url = apiUrl.apiUrl + '/purchasing/inquiry/add-lampiran/' + id
                    axios
                        .post(url, formData, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    html: response.data.message,
                                    icon: 'success',
                                    timer: 1000,
                                    timerProgressBar: true,
                                    willClose: () => {
                                        getLampiran()
                                    }
                                })
                            } else {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    html: response.data.message,
                                    icon: 'error'
                                })
                            }
                        })
                        .catch(error => {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: error.message,
                                icon: 'error'
                            })
                        })
                }
            })
        } else {
            handleCloseLampiran()
            Swal.fire({
                title: 'Pemberitahuan',
                html: msg,
                icon: 'warning'
            })
        }
    }

    const hapusLampiran = (id: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menghapus lampiran?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const formData = new FormData()

                const url = apiUrl.apiUrl + '/purchasing/inquiry/delete-lampiran/' + id
                axios
                    .post(url, formData, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getLampiran()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const onSubmit = (data: any) => {
        data.eta = data.eta.toISOString().split('T')[0]

        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/api/purchasing/inquiry/save'

                const headers = {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }

                const bodyFormData: any = new FormData()
                bodyFormData.append('pbsupplier_id', data.pbsupplier_id)
                bodyFormData.append('eta', data.eta)
                bodyFormData.append('detailBarang', data.detailBarang)
                bodyFormData.append('lampiran', JSON.stringify(listLampiran))

                bodyFormData.append('keterangan', data.keterangan)
                listLampiran.forEach(element => {
                    bodyFormData.append('file[]', element.file[0])
                })

                axios
                    .post(url, bodyFormData, {
                        headers: headers
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/inquiry')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }


    const checkExtension = (fileName: any) => {
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1)

        return extension
    }

    const tampilkanGambar = (url: string) => {
        if (
            url != '' &&
            url !=
            'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        ) {
            Swal.fire({
                imageUrl: url,
                imageAlt: 'Gambar'
            })
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Pemberitahuan',
                text: 'Gambar Tidak Tersedia'
            })
        }
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Inquiry
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Supplier
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pbsupplier_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSupplier}
                                                options={listSupplier}
                                                id='pbsupplier_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteSupplier}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Supplier'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.pbsupplier_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    ETA
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='eta'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='ETA'
                                                type='date'
                                                error={Boolean(errors.eta)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.eta && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tanggal Transaksi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='created_at'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal Transaksi'
                                                type='date'
                                                error={Boolean(errors.created_at)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.created_at && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                rows={2}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box sx={{ backgroundColor: '#ffeaa7', p: 1 }}>
                                    <Typography variant='body1' sx={{ color: '#212121', textAlign: 'center', fontWeight: 600 }}>
                                        DETAIL BARANG
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        mb: 1,
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Fab
                                        variant='extended'
                                        color='primary'
                                        sx={{ '& svg': { mr: 1 } }}
                                        onClick={() => handleClickDialog(true)}
                                    >
                                        <Icon icon='mdi:search' />
                                        Cari Barang
                                    </Fab>
                                    <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.open('/mm/master-barang/add', '_blank')}>
                                        <Icon icon='mdi:plus' />
                                        Tambah Master Barang
                                    </Fab>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ID Barang</TableCell>
                                                <TableCell>Nama Barang</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Satuan</TableCell>
                                                <TableCell>Harga</TableCell>
                                                <TableCell>Total</TableCell>
                                                <TableCell >Keterangan</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowsDataDetail.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item.mmbarang_id}</TableCell>
                                                    <TableCell>{item.nama}</TableCell>
                                                    <TableCell>{item.qty}</TableCell>
                                                    <TableCell>{item.satuan}</TableCell>
                                                    <TableCell>{item.harga}</TableCell>
                                                    <TableCell align='right'>{item.total}</TableCell>
                                                    <TableCell>{item.keterangan}</TableCell>
                                                </TableRow>
                                            ))}
                                            <TableRow>
                                                <TableCell colSpan={4}></TableCell>
                                                <TableCell>
                                                    <b>TOTAL :</b>
                                                </TableCell>
                                                <TableCell align='right'>
                                                    <b>{sumBarang.toLocaleString()}</b>
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box sx={{ backgroundColor: '#74ffff', p: 1 }}>
                                    <Typography variant='body1' sx={{ color: '#212121', textAlign: 'center', fontWeight: 600 }}>
                                        LAMPIRAN
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={5} sm={5}>
                                <Fab
                                    variant='extended'
                                    color='primary'
                                    sx={{ '& svg': { mr: 1 } }}
                                    onClick={() => {
                                        setFile(null)
                                        setTxtFile(null)
                                        setDialogLampiran(true)
                                    }}
                                >
                                    <Icon icon='mdi:add' />
                                    Tambah File
                                </Fab>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell sx={{ flex: 0.2, textAlign: 'center' }}>Jenis Lampiran</TableCell>
                                                <TableCell sx={{ width: 0.3, textAlign: 'center' }}>Nama File</TableCell>
                                                <TableCell sx={{ width: 0.3, textAlign: 'center' }}>Link</TableCell>
                                                <TableCell sx={{ width: 0.5, textAlign: 'center' }}>Keterangan</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {listLampiran.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        <IconButton color='error' onClick={() => hapusLampiran(item.id)}>
                                                            <Icon icon='mdi:trash' fontSize={20} />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell>{item.jenis_lampiran}</TableCell>
                                                    <TableCell sx={{ width: 0.3, textAlign: 'center' }}>{item.nama_file}</TableCell>
                                                    <TableCell sx={{ width: 0.5, textAlign: 'center' }}>{item.keterangan}</TableCell>
                                                    <TableCell sx={{ width: 0.5, textAlign: 'center' }}>
                                                        {checkExtension(item.link) == 'pdf' || checkExtension(item.link) == 'docx' || checkExtension(item.link) == 'xlsx' ? (
                                                            <Fab color='info' sx={{ mr: 0.5 }} size='small' onClick={() => window.open(item.link, '_blank')}>
                                                                <Icon icon='mdi:search' color='white' />
                                                            </Fab>
                                                        ) : (
                                                            <Fab color='info' sx={{ mr: 0.5 }} size='small' onClick={() => tampilkanGambar(item.link)}>
                                                                <Icon icon='mdi:search' color='white' />
                                                            </Fab>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                onClose={handleCloseLampiran}
                aria-labelledby='customized-dialog-title'
                open={dialogLampiran}
                fullWidth={true}
                maxWidth='sm'
            >
                <DialogTitle id='customized-dialog-title'>
                    <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                        Upload Lampiran
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={handleCloseLampiran}
                        sx={{ top: 10, right: 10, position: 'absolute', color: 'grey.500' }}
                    >
                        <Icon icon='mdi:close' />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 3 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}>
                                Jenis Lampiran
                            </Typography>
                            <FormControl fullWidth>
                                <InputLabel id='jenis_kampiran-label'>Jenis Lampiran</InputLabel>
                                <Select
                                    value={jenisLampiran}
                                    label='Jenis Lampiran'
                                    id='jenis_kampiran'
                                    onChange={handleChangeJenisLampiran}
                                >
                                    <MenuItem value='' selected>
                                        <em>Pilih Lampiran</em>
                                    </MenuItem>
                                    <MenuItem value={'MSDS / TDS'}>MSDS / TDS</MenuItem>
                                    <MenuItem value={'Laporan Trial'}>Laporan Trial</MenuItem>
                                    <MenuItem value={'Quotation'}>Quotation</MenuItem>
                                    <MenuItem value={'Lain - Lain'}>Lain - Lain</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                Upload File
                            </Typography>
                            <input
                                type='file'
                                ref={hiddenFileInput}
                                onChange={handleFile}
                                style={{ display: 'none' }}
                                accept='application/pdf,image/png, image/jpeg, image/jpg, .xls, .xlsx'
                            ></input>
                            <FormControl fullWidth>

                                <InputLabel htmlFor='input-file'>File</InputLabel>
                                <OutlinedInput
                                    label='Foto'
                                    value={txtFile}
                                    id='input-file'
                                    type={'text'}
                                    startAdornment={
                                        <Box
                                            onClick={handleClick}
                                            onMouseDown={e => e.preventDefault()}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <InputAdornment position='start'>
                                                Pilih File &nbsp;
                                                <IconButton edge='start' aria-label='paperclip'>
                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                </IconButton>
                                            </InputAdornment>
                                        </Box>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Keterangan
                                </Typography>
                                <TextField
                                    value={keterangan}
                                    label='Keterangan'
                                    onChange={handleChangeKeterangan}
                                    id='controlled-text-field'
                                    rows={2}
                                    multiline
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>

                    </Grid>
                    <div style={{ textAlign: 'center' }}>
                        <Button size='large' onClick={tambahLampiran} sx={{ mt: 5, width: 'auto' }} disabled={file == null} variant='contained'>
                            Tambah
                        </Button>
                    </div>
                </DialogContent>

                <Dialog
                    onClose={handleCloseDialog}
                    aria-labelledby='customized-dialog-title'
                    open={openBarang}
                    fullWidth={true}
                    maxWidth='xl'
                >
                    <DialogTitle id='customized-dialog-title'>
                        {isDetailBarang ? (
                            <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                                Pilih Barang
                            </Typography>
                        ) : (
                            <Typography variant='h6' component='span' sx={{ color: '#212121' }}>
                                Pilih Akun
                            </Typography>
                        )}
                        <IconButton
                            aria-label='close'
                            onClick={handleCloseDialog}
                            sx={{ top: 10, right: 10, position: 'absolute', color: 'grey.500' }}
                        >
                            <Icon icon='mdi:close' />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 4 }}>
                        <MsiDatagrid array={listDetailBarang} rowClick={rowClickBarang} />
                    </DialogContent>
                </Dialog>
            </Dialog>
        </Grid>
    )
}
